import PropTypes from 'prop-types';

const SidebarEmptyState = ({ showLikedOnly, searchQuery }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-6 text-center animate-fadeIn">
      <div className="max-w-xs">
        {searchQuery ? (
          <>
            {/* No Search Results */}
            <div className="mb-4">
              <svg
                className="w-16 h-16 mx-auto text-gray-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
            <h3 className="text-base font-semibold text-gray-700 mb-2">
              No Results Found
            </h3>
            <p className="text-sm text-gray-500 leading-relaxed">
              No chats match &quot;{searchQuery}&quot;. Try a different search term.
            </p>
          </>
        ) : showLikedOnly ? (
          <>
            {/* No Liked Chats */}
            <div className="mb-4">
              <svg
                className="w-16 h-16 mx-auto text-gray-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                />
              </svg>
            </div>
            <h3 className="text-base font-semibold text-gray-700 mb-2">
              No Liked Chats
            </h3>
            <p className="text-sm text-gray-500 leading-relaxed">
              Like your favorite conversations to find them here later.
            </p>
          </>
        ) : (
          <>
            {/* No History Yet */}
            <div className="mb-4">
              <svg
                className="w-16 h-16 mx-auto text-gray-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>
            </div>
            <h3 className="text-base font-semibold text-gray-700 mb-2">
              No Chat History
            </h3>
            <p className="text-sm text-gray-500 leading-relaxed">
              Start a conversation to see your chat history here. All your conversations will be saved automatically.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

SidebarEmptyState.propTypes = {
  showLikedOnly: PropTypes.bool,
  searchQuery: PropTypes.string
};

export default SidebarEmptyState;
